import _ from 'lodash';
import React from 'react';
import { UiThemeSetting } from '../graphql/generated/graphql';
import airtable from '../images/integrations/airtable/airtable.svg';
import asana from '../images/integrations/asana/asana.svg';
import atlassian from '../images/integrations/atlassian/atlassian.svg';
import confluence from '../images/integrations/atlassian/confluence.svg';
import jira from '../images/integrations/atlassian/jira.svg';
import bamboohr from '../images/integrations/bamboohr/bamboohr.svg';
import box from '../images/integrations/box/box.svg';
import canva from '../images/integrations/canva/canva.svg';
import clickup from '../images/integrations/clickup/clickup.svg';
import codepen from '../images/integrations/codepen/codepen.svg';
import drawio from '../images/integrations/drawio/drawio.svg';
import dropbox from '../images/integrations/dropbox/dropbox.svg';
import figma from '../images/integrations/figma/figma.svg';
import freshdesk from '../images/integrations/freshdesk/freshdesk.svg';
import github from '../images/integrations/github/github.svg';
import gitlab from '../images/integrations/gitlab/gitlab.svg';
import gliffy from '../images/integrations/gliffy/gliffy.svg';
import gmail from '../images/integrations/gmail/gmail.svg';
import calendar from '../images/integrations/google/calendar.svg';
import doc from '../images/integrations/google/doc.svg';
import drawing from '../images/integrations/google/drawing.svg';
import drive from '../images/integrations/google/drive.svg';
import form from '../images/integrations/google/form.svg';
import google from '../images/integrations/google/google.svg';
import map from '../images/integrations/google/map.svg';
import sheet from '../images/integrations/google/sheet.svg';
import slide from '../images/integrations/google/slide.svg';
import youtube from '../images/integrations/google/youtube.svg';
import guru from '../images/integrations/guru/guru.svg';
import height from '../images/integrations/height/height.svg';
import helpscout from '../images/integrations/helpscout/helpscout.svg';
import hubspot from '../images/integrations/hubspot/hubspot.svg';
import intercom from '../images/integrations/intercom/intercom.svg';
import invision from '../images/integrations/invision/invision.svg';
import v7 from '../images/integrations/invision/v7.svg';
import iorad from '../images/integrations/iorad/iorad.svg';
import jotform from '../images/integrations/jotform/jotform.svg';
import jsfiddle from '../images/integrations/jsfiddle/jsfiddle.svg';
import linear from '../images/integrations/linear/linear.svg';
import loom from '../images/integrations/loom/loom.svg';
import lucidchart from '../images/integrations/lucidchart/lucidchart.svg';
import ludus from '../images/integrations/ludus/ludus.svg';
import excel from '../images/integrations/microsoft/excel.svg';
import microsoft from '../images/integrations/microsoft/microsoft.svg';
import office from '../images/integrations/microsoft/office.svg';
import powerpoint from '../images/integrations/microsoft/powerpoint.svg';
import teams from '../images/integrations/microsoft/teams.svg';
import word from '../images/integrations/microsoft/word.svg';
import miro from '../images/integrations/miro/miro.svg';
import mode from '../images/integrations/mode/mode.svg';
import monday from '../images/integrations/monday/monday.svg';
import notion from '../images/integrations/notion/notion.svg';
import okta from '../images/integrations/okta/okta.svg';
import onelogin from '../images/integrations/onelogin/onelogin.svg';
import otter from '../images/integrations/otter/otter.svg';
import outlook from '../images/integrations/outlook/outlook.svg';
import pingboard from '../images/integrations/pingboard/pingboard.svg';
import pitch from '../images/integrations/pitch/pitch.svg';
import productboard from '../images/integrations/productboard/productboard.svg';
import quip from '../images/integrations/quip/quip.svg';
import rows from '../images/integrations/rows/rows.svg';
import salesforce from '../images/integrations/salesforce/salesforce.svg';
import shortcut from '../images/integrations/shortcut/shortcut.svg';
import slackApp from '../images/integrations/slack/slack-app.svg';
import slack from '../images/integrations/slack/slack.svg';
import slideshare from '../images/integrations/slideshare/slideshare.svg';
import smartsheet from '../images/integrations/smartsheet/smartsheet.svg';
import smartsheetWhite from '../images/integrations/smartsheet/smartsheetWhite.svg';
import tableau from '../images/integrations/tableau/tableau.svg';
import todoist from '../images/integrations/todoist/todoist.svg';
import trello from '../images/integrations/trello/trello.svg';
import twitter from '../images/integrations/twitter/twitter.svg';
import typeform from '../images/integrations/typeform/typeform.svg';
import vimeo from '../images/integrations/vimeo/vimeo.svg';
import whimsical from '../images/integrations/whimsical/whimsical.svg';
import wistia from '../images/integrations/wistia/wistia.svg';
import wrike from '../images/integrations/wrike/wrike.svg';
import guide from '../images/integrations/zendesk/guide.svg';
import support from '../images/integrations/zendesk/support.svg';
import zendesk from '../images/integrations/zendesk/zendesk.svg';
import useUiTheme from '../utils/useUiTheme';
import styles from './ExternalBrandLogo.module.scss';

export const PRODUCT_IMAGES = {
  airtable: { airtable },
  asana: { asana },
  atlassian: { atlassian, confluence, jira },
  bamboohr: { bamboohr },
  box: { box },
  clickup: { clickup },
  shortcut: { shortcut },
  clubhouse: { clubhouse: shortcut },
  drawio: { drawio },
  dropbox: { dropbox },
  figma: { figma },
  freshdesk: { freshdesk },
  github: { github },
  gitlab: { gitlab },
  gliffy: { gliffy },
  gmail: { gmail },
  google: {
    google,
    calendar,
    doc,
    drawing,
    drive,
    form,
    map,
    sheet,
    slide,
    youtube,
  },
  guru: { guru },
  height: { height },
  invision: { invision, v7 },
  iorad: { iorad },
  jotform: { jotform },
  linear: { linear },
  loom: { loom },
  lucidchart: { lucidchart },
  ludus: { ludus },
  microsoft: { microsoft, excel, office, powerpoint, teams, word },
  miro: { miro },
  mode: { mode },
  monday: { monday },
  notion: { notion },
  okta: { okta },
  onelogin: { onelogin },
  outlook: { outlook },
  pingboard: { pingboard },
  productboard: { productboard },
  quip: { quip },
  salesforce: { salesforce },
  slack: { slack, 'slack-app': slackApp },
  slideshare: { slideshare },
  todoist: { todoist },
  trello: { trello },
  vimeo: { vimeo },
  wistia: { wistia },
  wrike: { wrike },
  zendesk: { zendesk, guide, support },
  otter: { otter },
  typeform: { typeform },
  canva: { canva },
  smartsheet: { smartsheet },
  twitter: { twitter },
  codepen: { codepen },
  jsfiddle: { jsfiddle },
  hubspot: { hubspot },
  helpscout: { helpscout },
  intercom: { intercom },
  whimsical: { whimsical },
  pitch: { pitch },
  tableau: { tableau },
  rows: { rows },
} as const;

type BrandName = keyof typeof PRODUCT_IMAGES;

type ProductImageRecord<Type> = {
  [K in BrandName]: { [I in K]: Type } & Record<string, Type>;
};

type ProductImages = ProductImageRecord<string>;
type DarkModeInvert = Partial<ProductImageRecord<boolean>>;
type DarkModeOverride = Partial<ProductImages>;

const DARK_MODE_INVERT: DarkModeInvert = {
  github: { github: true },
  lucidchart: { lucidchart: true },
  onelogin: { onelogin: true },
  zendesk: { zendesk: true },
  typeform: { typeform: true },
  codepen: { codepen: true },
};

const DARK_MODE_OVERRIDE_IMAGES: DarkModeOverride = {
  smartsheet: { smartsheet: smartsheetWhite },
};

function getBrandImages<B extends BrandName>(brand: B): ProductImages[B] {
  return PRODUCT_IMAGES[brand];
}

export type BrandAndProductProps<B extends BrandName = BrandName> = B extends B
  ? {
      brand: B;
      product?: keyof ProductImages[B];
    }
  : never;

type ExternalBrandLogoProps<B extends BrandName> = {
  height?: number;
} & BrandAndProductProps<B>;

const ExternalBrandLogo = <B extends BrandName>(
  props: ExternalBrandLogoProps<B>,
) => {
  const uiTheme = useUiTheme();
  const isDark = uiTheme === UiThemeSetting.Dark;
  const productName = props.product ?? props.brand;

  const image = (() => {
    const brandImages = getBrandImages(props.brand);

    const finalImage = brandImages?.[productName] ?? brandImages?.[props.brand];

    if (isDark) {
      return (
        DARK_MODE_OVERRIDE_IMAGES[props.brand]?.[productName] ?? finalImage
      );
    }
    return finalImage;
  })();

  const className = DARK_MODE_INVERT[props.brand]?.[productName]
    ? styles.invert
    : undefined;

  if (!image) {
    return null;
  }

  return (
    <img
      alt={_.startCase(`${props.brand} ${productName} Logo`)}
      className={className}
      src={image}
      height={props.height}
    />
  );
};

export default ExternalBrandLogo;
